import PropTypes from 'prop-types';
import React from 'react';
import api from '../../../Api';
import makeConnectTo from '../../util/makeConnectTo';
import BrowseLaneType from '../Administer/BrowseLaneType';
import OptionSelectionTypes from '../Administer/OptionSelectionTypes';

const FilterOptionsContext = React.createContext();

export const useFilterOptions = () => React.useContext(FilterOptionsContext);

const name = 'filterOptionsDataStore';

export const connectToFilterOptions = makeConnectTo(FilterOptionsContext, name);

export default class FilterOptionsDataStore extends React.Component {
	static propTypes = {
		children: PropTypes.oneOfType([PropTypes.element, PropTypes.func]),
	};

	state = {
		filterOptions: [],
		filters: [],
		isLoading: true,
	};

	render() {
		const filterOptionsDataStore = this.getStore();
		return (
			<FilterOptionsContext.Provider value={filterOptionsDataStore}>
				{typeof this.props.children === 'function'
					? this.props.children(filterOptionsDataStore)
					: this.props.children}
			</FilterOptionsContext.Provider>
		);
	}

	componentDidMount() {
		this.fetchFilterOptions();
	}

	componentWillUnmount() {
		if (this.filterOptionsFetch && this.filterOptionsFetch.cancel) {
			this.filterOptionsFetch.cancel();
		}
	}

	getStore = (state = this.state) => ({
		state,
	});

	fetchFilterOptions = () => {
		const request = api.cancelableGet(`/api/v1/savedFilters/filterOptions`);
		request.promise.then(this.cacheApiResponse);
		this.filterOptionsFetch = request;
	};

	cacheApiResponse = apiResponse => {
		var filterOptions = [];
		Object.keys(BrowseLaneType).map(key => {
			if (
				BrowseLaneType[key].optionSelectionType ===
				OptionSelectionTypes.alpha
			) {
				filterOptions[
					BrowseLaneType[key].type
				] = this.sortByFirstLetter(
					apiResponse.filter(
						ar => ar.type === BrowseLaneType[key].type,
					),
				);
			}
		});
		this.setState({
			filters: apiResponse,
			filterOptions,
			isLoading: false,
		});
	};

	sortByFirstLetter = data => {
		return data.reduce((sortedFormats, format) => {
			if (format.displayName) {
				isNaN(format.displayName[0])
					? this.buildAndSortKeys(format, sortedFormats, false)
					: this.buildAndSortKeys(format, sortedFormats, true);
			}
			return sortedFormats;
		}, {});
	};

	buildAndSortKeys = (format, sortedFormats, isNumber) => {
		const key = isNumber ? '[0-9]' : format.displayName[0].toUpperCase();
		sortedFormats[key]
			? sortedFormats[key].push(format)
			: (sortedFormats[key] = [format]);
	};
}
